import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './module/index'
// import store from '../store';
import { createStore } from "@/store";
const store = createStore();

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push


VueRouter.prototype.push = function push(location) { 
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})


/**
 * 全局前置守卫
 * @param {Object} to 即将要进入的目标
 * @param {Object} from 当前导航正要离开的路由
 * @param {Function} next 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数
 */
router.beforeEach((to, from, next) => {
    // let isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
    // window.document.title = to.meta.title || '项目名'
    let isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
   
    if(isMobile){
        if(to.path === '/mobileUgc'){
            next()
        }else{
            next({path:'/mobileUgc'})
        }
    }else
    if (to.path === '/'){
        console.log(1);
        if (store.getters.token) {
            next({ path: '/skl/declarationCenter/projectDeclaration' })
        }else{
            next()
        }
    }
    else if(to.path === '/skl/declarationCenter/projectDeclaration'){
        console.log(2);
        if (store.getters.token) {
            next()
        }else{
            next({ path: '/' })
        }
    } 
    else{
        console.log(3);
        if (store.getters.token) {
          
            next()
        }else{
            next({ path: '/' })
        }
    }
})

/**
 * 全局后置钩子
 * @param {Object} to 
 * @param {Object} from 
 */
router.afterEach((to, from) => {
    // Vue.prototype.$NProgress.done();
    //每次切换页面的时候，让页面滚动到最顶部
    window.scrollTo(0, 0);

});


export function createRouter() {
    return router
}